import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { RULE_CATEGORIES_ACTION_TYPE } from '../actions';

const initialState = {};

const ruleCategoriesReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case RULE_CATEGORIES_ACTION_TYPE.GET_RULE_CATEGORIES:
        return payload || initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default ruleCategoriesReducer;
